import { render, staticRenderFns } from "./SelectWarehouseFromTo.vue?vue&type=template&id=bb0e2306&scoped=true&"
import script from "./SelectWarehouseFromTo.vue?vue&type=script&lang=js&"
export * from "./SelectWarehouseFromTo.vue?vue&type=script&lang=js&"
import style0 from "./SelectWarehouseFromTo.vue?vue&type=style&index=0&id=bb0e2306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0e2306",
  null
  
)

export default component.exports